<nav id=topnav class= "navbar topnavbar topwidth navbar-expand-lg navbar-light" role="navigation">
    <div class=" p-0" style="    display: flex;
    justify-content: space-between;
    width: 95%;">
        
          <div class="set-margin page-title">
            <h1 class="font-28 mt-2 gary-t font600 mb-0 l-h40 pl-3 pt-3" style="padding-top: 0px"> {{headerTitle}}</h1>
        </div>
        <div class="collapse navbar-collapse" [ngClass]="{ 'show': isShown }" id="navbarTogglerDemo03">
            <ul class="navbar-nav  ml-auto"> 
                <div class="container-fluid  p-0 in">
                    <div id="navigation" class="active">
                        <!-- Navigation Menu-->
                        <!-- <ul class="navigation-menu"> 
                            <li class="nav-item dropdown dropdown-list" dropdown>
                                <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
                                    <img src="assets/img/new/phone-icon.png" alt="" width="17px">
                                     
                                </a> 
                                <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
                                    <div class="dropdown-item"> 
                                        <div class="list-group"> 
                                           <p class="pt-2 text-center"> Download our app from</p>
                                           <div class="list-group-item list-group-item-action">
                                              <div class="media">
                                                
                                                 <div class="media-body text-center">
                                                  <a href="https://play.google.com/store/apps/details?id=com.xsilica.paygfuturepos" target="_blank"><img width="100px" src="assets/img/new/playstore-btn.png"></a>
                                                 </div>
                                              </div>
                                           </div> 
                                           <div class="list-group-item list-group-item-action">
                                              <div class="media">
                                                  
                                                 <div class="media-body text-center">
                                                    <a href="https://apps.apple.com/us/app/payg-future-pos/id1567618603" target="_blank"> <img width="100px" src="assets/img/new/app-store-btn.png"></a>
                                                 </div>
                                              </div>
                                           </div>
                                           
                                        </div> 
                                    </div>
                                </div> 
                            </li>  
                            <li class="has-submenu" (click)="isShown = false">
                                <a (click)="profilemenu = !profilemenu; $event.stopPropagation()">
                                    <i class="fas fa-user mr-2"></i>
                                    {{ username}}<div class="arrow-down"></div></a>
                                <ul class="submenu" [collapse]="profilemenu"> 
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/login']"> 
                                            <i class="fas fa-sign-out-alt"></i> Logout 
                                        </a>
                                    </li>
                                </ul>
                            </li> 
                        </ul> -->
                        <!-- End navigation menu -->

                        <div class="clearfix"></div>
                    </div>
                    <!-- end #navigation -->
                </div>
            </ul>

        </div>
    </div>
</nav>